import * as yup from 'yup'

export default yup.object().shape({
  name: yup.string().min(1).required('Required field'),
  contactName: yup.string(),
  email: yup.string(),
  phone: yup.string(),
  billingAddress: yup.string(),
})
